import React from 'react';
import { GlobeIcon, RefreshCwIcon, TargetIcon, MailIcon, ZapIcon, CloudIcon } from 'lucide-react';
const valueProps = [{
  icon: GlobeIcon,
  title: 'Full coverage',
  description: 'Access 200M+ local businesses across 50+ countries. Our database covers every category and location on Google Maps, giving you the most comprehensive dataset available.'
}, {
  icon: RefreshCwIcon,
  title: 'Real-time data',
  description: "Our data isn't just up-to-date — it's live. Business details, ratings, reviews, and contact info are continuously crawled and verified so you always work with fresh data."
}, {
  icon: TargetIcon,
  title: 'Lead generation',
  description: 'Turn raw Google Maps data into qualified leads. Enrich every business with owner emails, direct phone numbers, and LinkedIn profiles to power your outreach.'
}, {
  icon: MailIcon,
  title: 'Emails & contacts',
  description: 'Go beyond basic Google Maps data. Openmart enriches every record with verified emails, phone numbers, social media links, and decision-maker contact information.'
}, {
  icon: ZapIcon,
  title: 'Limitless speed',
  description: 'Extract thousands of businesses in minutes, not hours. Our infrastructure handles millions of records simultaneously with high-performance, globally distributed servers.'
}, {
  icon: CloudIcon,
  title: 'Cloud scraping',
  description: 'No proxies, no IP blocks, no maintenance. Openmart runs entirely in the cloud — our team continuously updates the scraping engine to handle any Google Maps changes.'
}];
export function ScraperValueProps() {
  return <section className="py-24 bg-white" data-id="element-1731">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1732">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1733">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1734">
            Why use Openmart for{' '}
            <span className="text-blue-600" data-id="element-1735">Google Maps</span> scraping?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1736">
          {valueProps.map((prop, index) => <div key={index} className="bg-slate-50 rounded-2xl p-8" data-id="element-1737">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center mb-5 shadow-sm border border-slate-100" data-id="element-1738">
                <prop.icon className="w-5 h-5 text-blue-600" data-id="element-1739" />
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-2" data-id="element-1740">
                {prop.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed" data-id="element-1741">
                {prop.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}